export function validURL(str) {
  var pattern = new RegExp(
    "^(https?:\\/\\/)?" +
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
      "((\\d{1,3}\\.){3}\\d{1,3}))" +
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
      "(\\?[;&a-z\\d%_.~+=-]*)?" +
      "(\\#[-a-z\\d_]*)?$",
    "i"
  );
  return !!pattern.test(str);
}

/**
 * Ensures a Loom URL is stored with an explicit scheme. Coaches often paste
 * `loom.com/share/...` straight from Loom's share dialog, but consumers that
 * resolve the URL (loom-embed's `oembed`, iframe `src`, `Linking.openURL`)
 * reject a schemeless value.
 * @param {string} str
 * @returns {string}
 */
export function normalizeLoomURL(str) {
  if (!str || typeof str !== "string") return str;
  const trimmed = str.trim();
  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
}

/**
 * Returns true only if the string is a valid Loom video URL (share or embed)
 * with an explicit http(s) scheme.
 * @param {string} str
 * @returns {boolean}
 */
export function validLoomURL(str) {
  if (!str || typeof str !== "string") return false;
  const trimmed = str.trim();
  // Loom IDs are 32 hex chars, optionally prefixed by a title slug
  // (e.g. "my-title-<id>"); allow trailing slash, query (?sid=, ?t=) and hash.
  const loomPattern =
    /^https?:\/\/(www\.)?loom\.com\/(share|embed)\/([a-z0-9]+(-[a-z0-9]+)*-)?[a-f0-9]{32}\/?(\?[^#\s]*)?(#\S*)?$/i;
  return loomPattern.test(trimmed);
}

/**
 * Function to truncate the text (add "...") if the string is bigger than the desired limit
 * @param {*} string
 * @param {*} limit
 * @returns
 */
export function truncateText(string = "", limit = 40) {
  if (string.length > limit) {
    return string.substring(0, limit) + "...";
  } else {
    return string;
  }
}

/**
 * Function to truncate the text (add "..." in the middle) if the string is bigger than the desired limit,
 * example of the return:com.mystrengthboo...qwegtyhiiktce.txt
 * @param {*} string
 * @param {*} limit
 * @returns
 */
export function truncateVideoText(string = "", limit = 23) {
  if (string.length > limit) {
    return (
      string.substring(0, 10) + "..." + string.substring(string.length - 10)
    );
  } else {
    return string;
  }
}

/**
 * Function to capitalize the first letter of a string
 * @param {*} val
 * @returns
 */
export const capitalizeFirstLetter = (val) => {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
};

/**
 * Function to validate links for youtube or loom only
 * @param {*} url
 * @returns
 */
export const isValidVideoLink = (url) => {
  const youtubeRegex =
    /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)[\w\-]{11}([?&]\S*)?$/i;
  const loomRegex = /^(https?:\/\/)?(www\.)?loom\.com\/share\/[a-zA-Z0-9]+$/i;

  return youtubeRegex.test(url.trim()) || loomRegex.test(url.trim());
};

/**
 * Function to see if the link is youtube or loom
 * @param {*} url
 * @returns
 */
export const getVideoPlatform = (url) => {
  const trimmed = url.trim();

  const youtubeRegex =
    /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)[\w\-]{11}([?&]\S*)?$/i;
  const loomRegex = /^(https?:\/\/)?(www\.)?loom\.com\/share\/[a-zA-Z0-9]+$/i;

  if (youtubeRegex.test(trimmed)) return "youtube";
  if (loomRegex.test(trimmed)) return "loom";
  return null;
};

export const safeURL = (url) => {
  if (!/^https?:\/\//i.test(url)) {
    return `https://${url}`;
  }
  return url;
};

/**
 * Function to generate a hash
 * @param {*} str
 * @returns
 */
export const simpleHash = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0;
  }
  return String(hash);
};
